import { guideSteps } from '@/mocks/homeData';

const icons = ['ri-calendar-check-line', 'ri-fire-line', 'ri-notification-3-line'];

export default function Guide() {
  return (
    <section id="guide" className="scroll-mt-20 bg-background-100/70 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="text-sm font-semibold tracking-widest text-primary-600">三步上手</span>
          <h2 className="mt-2 font-heading text-3xl font-black text-foreground-950 md:text-4xl">
            吃瓜指南<span className="text-primary-600">照表蹲守</span>
          </h2>
          <p className="mt-3 text-base text-foreground-600 md:text-lg">
            新朋友别慌，三个步骤就能把蹲瓜节奏完全拿捏，重要节点一个不落。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-3">
          {guideSteps.map((step, i) => (
            <div
              key={step.no}
              className="relative overflow-hidden rounded-2xl border border-background-200 bg-background-50 p-6 md:p-7"
            >
              <span className="absolute -right-3 -top-7 font-heading text-[6rem] font-black leading-none text-background-100/70">
                {String(i + 1).padStart(2, '0')}
              </span>
              <div className="relative">
                <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-accent-500 text-foreground-950">
                  <i className={`${icons[i]} text-2xl`} />
                </span>
                <div className="mt-5 font-latin text-xs tracking-widest text-accent-600">{step.no}</div>
                <h3 className="mt-1 font-heading text-xl font-bold text-foreground-950">{step.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{step.desc}</p>
              </div>
              {i < guideSteps.length - 1 && (
                <i className="ri-arrow-right-line absolute bottom-6 right-6 hidden text-2xl text-background-300 md:block" />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}